import clsx from 'clsx'
import React from 'react'
import {getCommonPinningStyles, getMonthsForYear} from './TanStackTableFn'
import {Table} from '@tanstack/react-table'
import {useIntl} from 'react-intl'
import {currencyFormatter} from '../../../functions/general'
import useUser from '../../../hooks/User'
import {MasterDataTableTanstack_CompanyCustom} from '../MasterDataTableTanstack'

{
  /* Debug */
}
{
  /* {table.getAllLeafColumns().map((column) => {
                  return (
                      <div key={column.id} className='px-1'>
                          <label>
                              <input
                                {...{
                                    type: 'checkbox',
                                    checked: column.getIsVisible(),
                                    onChange: column.getToggleVisibilityHandler(),
                                }}
                              />{' '}
                              {column.id}
                          </label>
                      </div>
                  )
              })} */
}

// ============================================================== Table Thead ==============================================================
export const CRM_Thead = <T extends object>({
  tableKey,
  table,
  tableHeaderStyle,
}: {
  tableKey: string
  table: Table<T>
  tableHeaderStyle?: React.CSSProperties
}) => {
  return (
    <thead style={{...tableHeaderStyle}}>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className='fw-bolder text-nowrap'>
          {headerGroup.headers.map((header) => {
            if (header.id.startsWith('year')) {
              return null
            }
            const columnRelativeDepth = header.depth - header.column.depth
            if (columnRelativeDepth > 1) {
              return null
            }

            let rowSpan = 1
            if (header.isPlaceholder) {
              const leafs = header.getLeafHeaders()
              rowSpan = leafs[leafs.length - 1].depth - header.depth
            }

            return (
              <th
                key={header.id}
                colSpan={header.colSpan}
                rowSpan={rowSpan}
                style={{
                  // padding: '1rem',
                  // width: '40px',
                  ...(header.column.columnDef.meta as any)?.styleHeader,
                  ...(tableKey !== 'reimbursement-limits'
                    ? getCommonPinningStyles(header.column)
                    : {}),
                }}
              >
                {/* {header.isPlaceholder ? null : ( */}
                <div
                  {...{
                    className: header.column.getCanSort()
                      ? 'cursor-pointer select-none flex min-w-[10px]'
                      : '',
                    onClick: header.column.getToggleSortingHandler(),
                  }}
                >
                  {header.column.columnDef.header &&
                  typeof header.column.columnDef.header === 'function'
                    ? header.column.columnDef.header(header.getContext())
                    : header.column.columnDef.header}
                  {{
                    asc: <span className='pl-2'>↑</span>,
                    desc: <span className='pl-2'>↓</span>,
                  }[header.column.getIsSorted() as string] ?? null}
                  {/* {header.column.getCanResize() && (
                                <div
                                    onMouseDown={header.getResizeHandler()}
                                    onTouchStart={header.getResizeHandler()}
                                    className={`resizer ${
                                        header.column.getIsResizing()
                                            ? 'isResizing'
                                            : ''
                                    }`}
                                ></div>
                              )} */}
                </div>
                {/* )} */}
              </th>
            )
          })}
        </tr>
      ))}
    </thead>
  )
}

// ============================================================== Table Tbody ==============================================================

export const CRM_Tbody = <T extends object>({
  tableKey,
  table,
  tableBodyStyle,
  onRowClicked
}: {
  tableKey: string
  table: Table<T>
  tableBodyStyle?: React.CSSProperties
  onRowClicked?: (row: any, event?: any) => void
}) => {
  const intl = useIntl()
  return (
    <tbody style={{...tableBodyStyle}} className='table-group-divider'>
    {table.getRowModel().rows.length > 0 ? (
      table.getRowModel().rows.map((row, rowIndex) => {
        let rowSpan = 1
        if (tableKey === 'dashboard-leads-report') {
          const descValue = row.getValue('desc')
          if (
            rowIndex === 0 ||
            descValue !== table.getRowModel().rows[rowIndex - 1].getValue('desc')
          ) {
            for (let i = rowIndex + 1; i < table.getRowModel().rows.length; i++) {
              if (table.getRowModel().rows[i].getValue('desc') === descValue) {
                rowSpan++
              } else {
                break
              }
            }
          } else {
            rowSpan = 0
          }
        }

        return (
          <tr
            key={row.id}
            // style={{
            //   ...tableRowStyle
            // }}
            // style={{
            //   ...(row.original as any)?.styleBody,
            // }}
            className={`border-top border-secondary ${
              rowIndex === table.getRowModel().rows.length - 1 ? 'border-bottom' : ''
            }`}
          >
            {row.getVisibleCells().map((cell) => {
              const isDescColumn = cell.column.id === 'desc'

              if (isDescColumn && rowSpan === 0) return null

              const isActionColumn =
                cell.column.columnDef.header === 'Aksi' ||
                cell.column.columnDef.header === 'Action'

              const Element = isActionColumn ? 'th' : 'td'

              // console.log('cell.column.columnDef.meta',cell.column.columnDef.meta)

              return (
                <Element
                  key={cell.id}
                  rowSpan={isDescColumn ? rowSpan : 1}
                  style={{
                    ...(cell.column.columnDef.meta as any)?.styleBody,
                    ...(tableKey !== 'reimbursement-limits'
                      ? getCommonPinningStyles(cell.column)
                      : {}),
                    ...(onRowClicked ? {cursor: 'pointer'} : {}),
                  }}
                  onClick={(event) => {
                    const target = event.target as HTMLElement

                    if (
                      target.tagName === 'A' ||
                      target.closest('a') ||
                      target.closest('button') ||
                      target.closest('[data-prevent-onRowClicked]')
                    ) {
                      return
                    }

                    if (!isActionColumn) {
                      onRowClicked && onRowClicked(row.original)
                    }
                  }}
                >
                  {typeof cell.column.columnDef.cell === 'function'
                    ? cell.column.columnDef.cell(cell.getContext())
                    : cell.column.columnDef.cell}
                </Element>
              )
            })}
          </tr>
        )
      })
    ) : (
      <tr>
        <td
          colSpan={table.getAllColumns().length}
          style={{textAlign: 'center', padding: '1rem'}}
        >
          <div className='d-flex justify-content-center align-items-center gap-4 fs-4 bg-light p-4'>
            <span>
              {intl.formatMessage({id: 'FORM.LABEL.DATA_SEARCHING_NOT_FOUND'})}
            </span>
          </div>
        </td>
      </tr>
    )}
  </tbody>
  );
};


// ============================================================== Reimbursement Limit Componenents ==============================================================

export const ReimbursementLimit_Info = () => {
  const intl = useIntl()
  return (
    <>
      <div className='d-flex justify-content-end my-1 w-100 flex-wrap'>
        <span className='fw-bolder'>{intl.formatMessage({id: 'FORM.LABEL.SET'})}</span>
        <span className='ms-5 d-flex'>
          <span
            className='w-20px h-20px border me-2'
            style={{borderRadius: '6px', backgroundColor: '#E8FFF3'}}
          ></span>
          {intl.formatMessage({id: 'FORM.LABEL.DONE'})}
        </span>
        <span className='ms-4 d-flex'>
          <span
            className='w-20px h-20px border me-2'
            style={{borderRadius: '6px', backgroundColor: '#fee0e0'}}
          ></span>
          {intl.formatMessage({id: 'FORM.LABEL.FOLLOWING_PREVIOUS_MONTH'})}
        </span>
      </div>
    </>
  )
}

interface ReimbursementLimit_TBodyProps<T> {
  table: Table<T>
}

export const ReimbursementLimit_TBody: React.FC<ReimbursementLimit_TBodyProps<any>> = ({table}) => {
  return (
    <>
      <tbody>
        {table.getRowModel().rows.map((row, rowIndex) => (
          <React.Fragment key={rowIndex}>
            <tr>
              {row.getVisibleCells().map((cell) => {
                const key = cell.column.columnDef.id as string
                if (key.startsWith('month') || key.startsWith('year')) {
                  return null // Skip month and year keys in the first row
                }
                return (
                  <td
                    key={cell.id}
                    rowSpan={2}
                    className={clsx((cell.column.columnDef.meta as any)?.classNames)}
                    style={{
                      ...(cell.column.columnDef.meta as any)?.styleBody,
                    }}
                  >
                    {typeof cell.column.columnDef.cell === 'function'
                      ? cell.column.columnDef.cell(cell.getContext())
                      : cell.column.columnDef.cell}
                  </td>
                )
              })}
              {row
                .getVisibleCells()
                .filter((cell) => {
                  const key = cell.column.columnDef.id as string
                  return key.startsWith('year')
                })
                .map((cell) => {
                  const key = cell.column.columnDef.id as string
                  const year = key.split('_')[1]
                  const monthsForYear = getMonthsForYear(row.original, year)
                  return (
                    <td
                      key={cell.id}
                      colSpan={monthsForYear.length}
                      className={clsx((cell.column.columnDef.meta as any)?.classNames)}
                      style={{
                        ...(cell.column.columnDef.meta as any)?.styleBody,
                      }}
                    >
                      {typeof cell.column.columnDef.cell === 'function'
                        ? cell.column.columnDef.cell(cell.getContext())
                        : cell.column.columnDef.cell}
                    </td>
                  )
                })}
            </tr>
            <tr>
              {row
                .getVisibleCells()
                .filter((cell) => {
                  const key = cell.column.columnDef.id as string
                  return key.startsWith('month')
                })
                .map((cell) => {
                  return (
                    <td
                      key={cell.id}
                      className={clsx((cell.column.columnDef.meta as any)?.classNames)}
                      style={{
                        ...(cell.column.columnDef.meta as any)?.styleBody,
                      }}
                    >
                      {typeof cell.column.columnDef.cell === 'function'
                        ? cell.column.columnDef.cell(cell.getContext())
                        : cell.column.columnDef.cell}
                    </td>
                  )
                })}
            </tr>
          </React.Fragment>
        ))}
      </tbody>
    </>
  )
}

// ============================================================== Pagination ==============================================================
export const CRM_Pagination = <T extends object>({table}: {table: Table<T>}) => {
  return (
    <div className='d-flex justify-content-end align-items-center flex-wrap pt-10'>
      <div className='d-flex align-items-center gap-3'>
        <div className='d-flex align-items-center gap-5'>
          <select
            className='form-select form-select-sm font-weight-bold mr-4 border-0 bg-light'
            style={{width: '75px'}}
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              table.setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
          <div className='fs-7 text-gray-700'>
            {table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1} -{' '}
            {Math.min(
              (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
              table.getFilteredRowModel().rows.length
            )}{' '}
            of {table.getFilteredRowModel().rows.length}
          </div>
        </div>
        <nav>
          <ul className='pagination mb-0'>
            <li className={`page-item ${!table.getCanPreviousPage() ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => table.setPageIndex(0)}
                disabled={!table.getCanPreviousPage()}
              >
                <i className='fas fa-angle-double-left'></i>
              </button>
            </li>
            <li className={`page-item ${!table.getCanPreviousPage() ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
              >
                <i className='fas fa-angle-left'></i>
              </button>
            </li>
            <li className={`page-item ${!table.getCanNextPage() ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}
              >
                <i className='fas fa-angle-right'></i>
              </button>
            </li>
            <li className={`page-item ${!table.getCanNextPage() ? 'disabled' : ''}`}>
              <button
                className='page-link'
                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                disabled={!table.getCanNextPage()}
              >
                <i className='fas fa-angle-double-right'></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  )
}

// ============================================================== Custom Company ==============================================================
export const CustomCompanyView = ({
  companyCustom,
}: {
  companyCustom: MasterDataTableTanstack_CompanyCustom
}) => {
  const user = useUser()
  return (
    <>
      {/* --- MASPION View--- */}
      {companyCustom.maspion.totalDpp && companyCustom.maspion.totalDpp > 0 ? (
        <div className='d-flex justify-content-end align-items-center flex-wrap'>
          <div className='d-flex align-items-center gap-3 fw-bolder fs-5'>
            <span>Total DPP :</span>
            <span>
              {currencyFormatter(
                companyCustom.maspion.totalDpp,
                user?.data?.companyCurrencyNeedRound,
                user?.data?.companyCurrency,
                {showPrefix: true}
              )}
            </span>
          </div>
        </div>
      ) : null}
      {companyCustom.maspion.totalPPN && companyCustom.maspion.totalPPN > 0 ? (
        <div className='d-flex justify-content-end align-items-center flex-wrap'>
          <div className='d-flex align-items-center gap-3 fw-bolder fs-5'>
            <span>Total PPN :</span>
            <span>
              {currencyFormatter(
                companyCustom.maspion.totalPPN,
                user?.data?.companyCurrencyNeedRound,
                user?.data?.companyCurrency,
                {showPrefix: true}
              )}
            </span>
          </div>
        </div>
      ) : null}
      {companyCustom.maspion.totalJumlah && companyCustom.maspion.totalJumlah > 0 ? (
        <div className='d-flex justify-content-end align-items-center flex-wrap'>
          <div className='d-flex align-items-center gap-3 fw-bolder fs-5'>
            <span>Total Jumlah :</span>
            <span>
              {currencyFormatter(
                companyCustom.maspion.totalJumlah && companyCustom.maspion.totalJumlah,
                user?.data?.companyCurrencyNeedRound,
                user?.data?.companyCurrency,
                {showPrefix: true}
              )}
            </span>
          </div>
        </div>
      ) : null}
    </>
  )
}